import { render, staticRenderFns } from "./PiechartRevenueFuelNonFuel.vue?vue&type=template&id=52a9b10a"
import script from "./PiechartRevenueFuelNonFuel.vue?vue&type=script&lang=js"
export * from "./PiechartRevenueFuelNonFuel.vue?vue&type=script&lang=js"
import style0 from "./PiechartRevenueFuelNonFuel.vue?vue&type=style&index=0&id=52a9b10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports